import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDarkreaderComponent } from './simple-icons-darkreader.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDarkreaderComponent ],
    exports:      [ SimpleIconsDarkreaderComponent ],
    bootstrap:    []
})
export class SimpleIconsDarkreaderModule {}
